import { Button, ButtonGroup, Text, useToast, VStack } from "@chakra-ui/react"
import React from "react"
import { NavLink, useNavigate } from "react-router-dom"
import { ExtendedZoneFragment, useRemoveIBeaconFromZoneMutation } from "../../graphql"

export type RemoveIBeaconFromZoneProps = {
	zone: ExtendedZoneFragment
	ibeaconId: string
}

export const RemoveIBeaconFromZone: React.FC<RemoveIBeaconFromZoneProps> = ({ zone, ibeaconId }) => {
	const [{ fetching }, remove] = useRemoveIBeaconFromZoneMutation()

	const toast = useToast()
	const navigate = useNavigate()

	const handleRemove = async () => {
		const { error, data } = await remove({ zoneId: zone._id, ibeaconId })

		if (error) {
			toast({ description: error.message.replace("[GraphQL] ", ""), status: "error" })
			return
		}

		if (data?.removeIBeaconFromZone) {
			toast({ description: "Removed the iBeacon successfully", status: "success" })
			navigate(`/zones/${zone._id}`)
			return
		} else {
			toast({ description: "Couldn't remove the iBeacon", status: "error" })
			return
		}
	}

	return (
		<VStack w="full" maxW={{ base: "full", xl: "2xl" }} align="stretch" spacing={4}>
			<VStack w="full" align="flex-end" spacing={4}>
				<Text fontSize="sm" color="grayscale.label" alignSelf="flex-start">
					Are you sure you want to remove the iBeacon from {zone.label.name}?
				</Text>
				<ButtonGroup>
					<Button size="sm" as={NavLink} to={`/zones/${zone._id}`}>
						Cancel
					</Button>
					<Button size="sm" colorScheme="error" isLoading={fetching} onClick={handleRemove}>
						Remove
					</Button>
				</ButtonGroup>
			</VStack>
		</VStack>
	)
}
